module.exports = __webpack_public_path__ + "static/bgf_img01@2x-dcbd16178ac8926fc2cdecbf50709a2a.jpg";